import React from 'react';
import EventCard from './EventCard';
import EventCardSkeleton from './EventCardSkeleton';

const EventGrid = ({ events = [], loading = false, className = '' }) => {
  
  if (loading) {
    return (
      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 ${className}`}>
        {[...Array(12)]?.map((_, index) => (
          <EventCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (!events?.length) {
    return (
      <div className={`${className}`}>
        <div className="text-center py-12">
          <div className="text-6xl mb-4">🎫</div>
          <h3 className="text-xl font-semibold text-foreground mb-2">
            No Events Available
          </h3>
          <p className="text-muted-foreground">
            Check back later for new events or adjust your filters
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 ${className}`}>
      {events?.map((event) => (
        <EventCard 
          key={event?.id || event?.name || Math.random()} 
          event={event}
        />
      ))}
    </div>
  );
};

export default EventGrid;